<template>
  <div id="appdown">
    <div class="banner"></div>
    <div class="down">
      <a href="https://a.app.qq.com/o/simple.jsp?pkgname=com.ysedu.ydjs&fromcase=40003"><img src="../../assets/icon/appdown_icon_andriod.png" alt=""> 安卓下载</a>
      <a href="https://apps.apple.com/cn/app/id1445823805"><img src="../../assets/icon/appdown_icon_ios.png" alt=""> ios下载</a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppDownLoad'
}
</script>

<style scoped lang="stylus">
  #appdown
    .banner
      height: 7.66rem
      background: url(../../assets/img/appdown_img_phone.png) no-repeat center bottom #e4eaea
      -webkit-background-size: 5.37rem 6.19rem
      background-size: 5.37rem 6.19rem
    .down
      padding: 1.48rem 0 0
      a
        display: block
        width: 4.45rem
        height: 1rem
        line-height: 1rem
        background-color: #0082fa
        margin: 0 auto .65rem
        font-size: .36rem
        color: #fff
        text-align: center
        -webkit-border-radius: 3rem
        -moz-border-radius: 3rem
        border-radius: 3rem
        img
          position: relative
          top: .02rem
          width: .31rem
          height: .38rem
        &:first-child
          img
            width: .32rem
            height: .39rem
</style>



// WEBPACK FOOTER //
// src/components/single/AppDownLoad.vue